export const MODULE_FOOTER = 'footer';
export const MODULE_HEADER = 'header';
export const MODULE_HEADER_MOBILE = 'headerMobile';
